<template>
    <div class="selection-menu">
        <div class="item" :class="step_==index?'active':''"
             v-for="(item,index) in list.step[step].step_" :key="index"
             @click="step_==index?()=>{}:$router.push(`/experiment_${step}_${index}`)">
            {{item.name}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "SelectionMenu",
        props:{
            list:[Object,Array],
            step:[Number,String],
            step_:[Number,String]
        }
    }
</script>

<style scoped lang="scss">
    $rem:0.01rem;
    div.selection-menu {
        display: flex;
        div.item {
            width: 116*$rem;
            height: 40*$rem;
            border: 1*$rem solid #25FCFF;
            background: #2c3e50;
            box-shadow: 0 0 10*$rem #25FCFF inset;
            font-weight: bolder;
            font-family: "SimHei", serif;
            font-size: 16*$rem;
            text-align: center;
            line-height: 40*$rem;
            margin-right: 16*$rem;
            cursor: pointer;
            transition: box-shadow 0.6s ease-in-out;
            &:hover {
                box-shadow: 0 0 30*$rem #25FCFF inset;
                transition: box-shadow 0.6s ease-in-out;
            }

            &.active {
                border: 1*$rem solid #FF8700;
                box-shadow: 0 0 10*$rem #FF8700 inset;
                background: #540101;
                &:hover {
                    box-shadow: 0 0 30*$rem #FF8700 inset;
                    transition: box-shadow 0.6s ease-in-out;
                }
            }
        }
    }
</style>
